/**
 * URL of the @gitlab/svgs icon sprite, resolved by Vite.
 *
 * Using `?url` tells Vite to treat this as a static asset and return its
 * public URL.  In dev mode the file is served directly from node_modules by
 * the Vite dev server.  In production it is hashed and emitted into
 * public/assets/ alongside all other compiled assets
 *
 * All <use :href="iconHref(name)"> references in components point here so
 * that fill="currentColor" on the host <svg> element picks up the CSS `color`
 * property via currentColor, giving icons the correct Pajamas token colors.
 *
 * @param {string} name - GitLab icon name (e.g. "chevron-down", "status-success")
 * @returns {string} absolute URL fragment, e.g. "/assets/icons-abc123.svg#status-success"
 */
import spriteUrl from "@gitlab/svgs/dist/icons.svg?url";
import fileIconSpriteUrl from "@gitlab/svgs/dist/file_icons/file_icons.svg?url";

export function iconHref(name) {
  return `${spriteUrl}#${name}`;
}

export function fileIconHref(name) {
  return `${fileIconSpriteUrl}#${name}`;
}
